export const WELL_ATTRIBUTES_NAME_ERROR = "Well must have a name"
export const WELL_ATTRIBUTES_LATITUDE_ERROR = "Enter valid latitude"
export const WELL_ATTRIBUTES_LONGITUDE_ERROR = "Enter valid longitude"
export const WELL_ATTRIBUTES_API_ERROR = "Enter a valid API #"
